/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Add_EducationInputs */

const en_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Education`)
};

const de_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ausbildung hinzufuegen`)
};

const fr_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Ajouter une formation`)
};

const es_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Anadir formacion`)
};

const it_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Aggiungi formazione`)
};

const nl_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Opleiding toevoegen`)
};

const pl_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Dodaj wyksztalcenie`)
};

const fi_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lisää koulutus`)
};

const da_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Tilföj uddannelse`)
};

const sv_resume_editor_add_education = /** @type {(inputs: Resume_Editor_Add_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Lagg till utbildning`)
};

/**
* | output |
* | --- |
* | "+ Add Education" |
*
* @param {Resume_Editor_Add_EducationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_add_education = /** @type {((inputs?: Resume_Editor_Add_EducationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Add_EducationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_add_education(inputs)
	if (locale === "fr") return fr_resume_editor_add_education(inputs)
	if (locale === "es") return es_resume_editor_add_education(inputs)
	if (locale === "it") return it_resume_editor_add_education(inputs)
	if (locale === "nl") return nl_resume_editor_add_education(inputs)
	if (locale === "pl") return pl_resume_editor_add_education(inputs)
	if (locale === "fi") return fi_resume_editor_add_education(inputs)
	if (locale === "da") return da_resume_editor_add_education(inputs)
	if (locale === "sv") return sv_resume_editor_add_education(inputs)
	return en_resume_editor_add_education(inputs)
});